module.exports = __webpack_public_path__ + "img/141ne.878707b4.svg";